<app-form-control class="form-control">
  <div appFormControlLabel>{{ payload.label }}</div>
  <app-multi-autocomplete appFormControlInput class="form-control-input" [formControl]="formControl">
    <ng-container *ngFor="let item of payload.options">
      <ng-container *appMultiAutocompleteOption="item.value; searchValue: item.viewValue">{{ item.viewValue }}</ng-container>
    </ng-container>
  </app-multi-autocomplete>
  <span *ngIf="payload.hint" appFormControlHint>{{ payload.hint }}</span>
</app-form-control>
